import { debug, i18n, observer, React, styled, theme, ui } from "aaa";
import * as config from "config";
import { IDS } from "i18n/util";
import * as _ from "lodash";
import { Route, RouteComponentProps } from "react-router-dom";
import { BaseDataForm } from "./BaseDataForm";
import { ContactForm } from "./ContactForm";
import { CreditInfoBox } from "./CreditInfoBox";
import { DocumentsForm } from "./DocumentsForm";
import { ExpensesForm } from "./ExpensesForm";
import { GlobalFooter } from "./GlobalFooter";
import { GlobalHeader } from "./GlobalHeader";
import { IncomeForm } from "./IncomeForm";
import { InterestRatesForm } from "./InterestRatesForm";
import { LoanCalculator } from "./LoanCalculator";
import { Login } from "./Login";
import { NAVBAR_STEPS, NavigationBar } from "./NavigationBar";
import { RequestPassword } from "./RequestPassword";
import { SetPassword } from "./SetPassword";
import { SuccessScreen } from "./SuccessScreen";
import { Summary } from "./Summary";

const styles = {
    cardSubtitle: {
        fontSize: 14,
        marginTop: 5,
        marginBottom: 3,
        color: "#102648",
        fontFamily: "Arial, sans-serif",
        lineHeight: 1.5,
    },
    text: {
        fontSize: 14,
        color: "#102648",
        fontFamily: "Arial, sans-serif",
        lineHeight: 1.5,
        marginTop: 0,
    },
};

type IState = {};
type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps;

let __: any;

const HEADER_HEIGHT = 100;
const BANNER_HEIGHT = 140;
const SIEGEL_HEIGHT = 160;

const Header = styled.h1`
    margin-top: 0px;
    margin-bottom: 0px;
    color: white;
    position: absolute;
    bottom: 10px;
    left: ${theme.MARGIN_BIG}px;

    @media (max-width: 749px) {
        bottom: 0px;
        top: 20px;
        left: 15px;
    }
`;

const TopBarContainer = styled.div`
    height: 180px;
    background: #005fa6;
    position: relative;
    display: flex;
    flex-direction: column-reverse;

    @media (min-width: 750px) {
        height: 100px;
    }
`;

const BannerMobile = styled.img`
    top: 0px;

    @media (max-width: 749px) {
        top: 40px;
    }
`;

const TopBar = (props: {
    titleId: IDS;
    showBanner: boolean;
    showAward: boolean;
}) => (
        <TopBarContainer>
            <Header>
                <i18n.FormattedHTMLMessage id={props.titleId} />
            </Header>

            {
                props.showBanner ? (
                    <div>
                        <BannerMobile
                            src={require("../assets/banner.png")}
                            style={{
                                position: "absolute",
                                height: BANNER_HEIGHT,
                                right: 0,
                                pointerEvents: "none"
                            }}
                        />
                    </div>
                ) : (
                        <div style={{ textAlign: "right" }}>
                            <CreditInfoBox />
                        </div>
                    )
                // < Mobile >
                //         <img
                //             src={require("../assets/siegel.jpg")}
                //             style={{
                //                 position: "absolute",
                //                 height: SIEGEL_HEIGHT,
                //                 right: theme.MARGIN / 2,
                //                 top: HEADER_HEIGHT,
                //             }}
                //         />
                //     </Mobile>
            }

            {/* {props.showAward &&
            <Desktop>
                <img
                    src={require("../assets/siegel.jpg")}
                    style={{
                        position: "absolute",
                        height: SIEGEL_HEIGHT,
                        right: theme.MARGIN / 2,
                        top: 0,
                    }}
                />
            </Desktop>
        } */}
        </TopBarContainer>
    );

const Separator = () => <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>;

// const InfoBox = () => (
//     <div>
//         <h1
//             style={{
//                 fontSize: 20,
//                 color: "#102648",
//                 fontFamily: "Arial, sans-serif",
//                 marginTop: 40,
//                 lineHeight: 1.3,
//                 marginBottom: 30,
//             }}
//         >
//             {ui.__("infoBox.header")}
//         </h1>
//         <h2
//             style={{
//                 fontSize: 15,
//                 color: "#2f72be",
//                 fontFamily: "Arial, sans-serif",
//                 marginBottom: 30,
//             }}
//         >
//             <i18n.FormattedHTMLMessage id="infoBox.darlehen" />
//         </h2>
//         <p
//             style={{
//                 fontSize: 14,
//                 color: "#102648",
//                 fontFamily: "Arial, sans-serif",
//                 lineHeight: 1.5,
//                 marginTop: 0,
//             }}
//         >
//             {ui.__("infoBox.aufEinenBlick")}
//         </p>
//         <ul style={{ paddingLeft: 20 }}>
//             <li style={styles.cardSubtitle}>{ui.__("infoBox.list.immo")}</li>
//             <li style={styles.cardSubtitle}>
//                 {ui.__("infoBox.list.laufzeit")}
//             </li>
//             <li style={styles.cardSubtitle}>{ui.__("infoBox.list.zusage")}</li>
//             <li style={styles.cardSubtitle}>
//                 {ui.__("infoBox.list.auszahlung")}
//             </li>
//         </ul>
//     </div>
// );

@i18n.injectIntl
@observer
export class Container extends React.Component<IProps, IState> {
    highestNavigationStep = 0;
    previouslySubmittedFields: string[] = [];

    constructor(props: IProps) {
        super(props);
        ui.__ = i18n.bindStr(this.props.intl);
        __ = ui.__;
    }

    componentDidMount() {
        // Custom messages not supported anymore https://stackoverflow.com/questions/9626059/window-onbeforeunload-in-chrome-what-is-the-most-recent-fix
        // https://stackoverflow.com/questions/3888902/detect-browser-or-tab-closing
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
        const self = this;
        window.addEventListener("beforeunload", function (e) {
            debug.log("beforeunload", e);

            // Cancel the event as stated by the standard.
            if (!config.DEBUG) {
                e.preventDefault();

                // try to send
                const confirmationMessage = "Wollen Sie die Seite verlassen?";

                (e || window.event).returnValue = confirmationMessage; // Gecko + IE
                return confirmationMessage; // Webkit, Safari, Chrome
            }
        });
    }

    componentWillMount() {
        ui.addResizeListener();
    }

    componentWillUnmount() {
        ui.removeResizeListener();
        window.removeEventListener("beforeunload");
    }

    basePath() {
        let path = this.props.location.pathname;
        const components = path.split("/");
        if (components.length >= 2) {
            path = "/" + components[1];
        }

        return path;
    }

    getTitleId(): i18n.IDS {
        const mapping = {
            "/": ui.windowWidth < 580 ? "header.loan.mobile" : "header.loan",
            "/loan":
            ui.windowWidth < 580 ? "header.loan.mobile" : "header.loan",
            "/base": "header.baseData",
            // "/tax": "header.taxData",
            // "/personal": "header.personalData",
            "/contact": "header.contactInformation",
            "/income": "header.income",
            "/expenses": "header.expenses",
            "/summary": "header.summary",
            "/interest-rates": "header.interestRates",
            "/login": "header.login",
            "/success": "header.success",
            "/documents": "header.documents",
            "/request-password": "header.requestPassword",
            "/set-password": "password.password",
        };

        let title: i18n.IDS = "unknown.title";

        if (this.props.location) {
            title = mapping[this.basePath()];
        }

        return title || "unknown.title";
    }

    getTitle() {
        return __(this.getTitleId());
    }

    showAward() {
        const pathname = this.basePath();
        return (
            pathname !== "/login" &&
            pathname !== "/interest-rates" &&
            pathname !== "/request-password" &&
            pathname !== "/set-password"
        );
    }

    onFormStepSubmit = (keysSubmittedFields: string[]) => {
        debug.log("onFormStepSubmit", keysSubmittedFields);

        this.previouslySubmittedFields = [
            ...keysSubmittedFields,
            ...this.previouslySubmittedFields,
        ];
    }

    getNavBarIndex = () => {
        return _.indexOf(NAVBAR_STEPS, this.props.history.location.pathname);
    }

    render() {
        const ContainerDiv = styled.div`
            max-width: ${theme.MAX_APP_WIDTH}px;
            background: white;
            margin-left: auto;
            margin-right: auto;
        `;

        const showBanner =
            this.props.history.location.pathname === "/" ||
            this.props.history.location.pathname === "/loan";

        const SIDE_PADDING = 0;

        const navBarIndex = this.getNavBarIndex();
        this.highestNavigationStep = Math.max(
            this.highestNavigationStep,
            navBarIndex
        );

        return (
            <div>
                <main style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                    <GlobalHeader />
                    <br />
                    <ContainerDiv
                        style={
                            ui.isMobile
                                ? {
                                    minHeight: "100vh",
                                    paddingLeft: SIDE_PADDING,
                                    paddingRight: SIDE_PADDING,
                                }
                                : {
                                    paddingLeft: SIDE_PADDING,
                                    paddingRight: SIDE_PADDING,
                                }
                        }
                    >
                        <TopBar
                            titleId={this.getTitleId()}
                            showBanner={showBanner}
                            showAward={this.showAward()}
                        />

                        {navBarIndex >= 0 && (
                            <NavigationBar
                                step={navBarIndex}
                                highestStep={this.highestNavigationStep}
                                history={this.props.history}
                            />
                        )}

                        <Route exact path="/" component={LoanCalculator as any} />
                        <Route path="/loan" component={LoanCalculator as any} />

                        <Route
                            path="/base"
                            render={(props: any) => (
                                <BaseDataForm
                                    {...props}
                                    onSubmit={this.onFormStepSubmit}
                                />
                            )}
                        />
                        <Route
                            path="/contact"
                            render={(props: any) => (
                                <ContactForm
                                    {...props}
                                    onSubmit={this.onFormStepSubmit}
                                />
                            )}
                        />
                        <Route
                            path="/income"
                            render={(props: any) => (
                                <IncomeForm
                                    {...props}
                                    onSubmit={this.onFormStepSubmit}
                                />
                            )}
                        />
                        <Route
                            path="/expenses"
                            render={(props: any) => (
                                <ExpensesForm
                                    {...props}
                                    onSubmit={this.onFormStepSubmit}
                                />
                            )}
                        />
                        <Route
                            path="/documents"
                            render={(props: any) => (
                                <DocumentsForm
                                    {...props}
                                    onSubmit={this.onFormStepSubmit}
                                />
                            )}
                        />

                        <Route path="/summary" component={Summary as any} />
                        <Route path="/success" component={SuccessScreen as any} />

                        <Route
                            path="/interest-rates"
                            component={InterestRatesForm as any}
                        />
                        <Route path="/login" component={Login as any} />
                        <Route
                            path="/request-password"
                            component={RequestPassword as any}
                        />
                        <Route
                            exact
                            path="/set-password/:resetToken"
                            component={SetPassword as any}
                        />
                        <Route
                            exact
                            path="/set-password"
                            component={SetPassword as any}
                        />

                        {ui.renderMessageBox()}
                        {ui.renderSnackbar()}
                    </ContainerDiv>
                    <br />
                </main>
                <GlobalFooter />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Container.tsx